import { render, staticRenderFns } from "./PublicMenuWrapper.vue?vue&type=template&id=61f8d2a9&scoped=true&"
import script from "./PublicMenuWrapper.vue?vue&type=script&lang=js&"
export * from "./PublicMenuWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PublicMenuWrapper.vue?vue&type=style&index=0&id=61f8d2a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f8d2a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
